module.exports = __webpack_public_path__ + "static/Auto-Photo-Main-d98d0ebc8ab257a5e1fba7878483beeb.jpg";